import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { SimpleError } from '@simonbackx/simple-errors';
import { v4 as uuidv4 } from 'uuid';
export class WebshopField extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = '';
        this.description = '';
        this.placeholder = '';
        this.required = true;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], WebshopField.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], WebshopField.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder })
], WebshopField.prototype, "description", void 0);
__decorate([
    field({ decoder: StringDecoder })
], WebshopField.prototype, "placeholder", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 95 })
], WebshopField.prototype, "required", void 0);
export class WebshopFieldAnswer extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.answer = '';
    }
    validate() {
        if (this.field.required && this.answer.length === 0) {
            throw new SimpleError({
                code: 'invalid_field',
                message: 'This field is required',
                human: $t(`%tH`),
                field: 'answer',
            });
        }
    }
}
__decorate([
    field({ decoder: WebshopField })
], WebshopFieldAnswer.prototype, "field", void 0);
__decorate([
    field({ decoder: StringDecoder })
], WebshopFieldAnswer.prototype, "answer", void 0);
//# sourceMappingURL=WebshopField.js.map